<template>
  <CustomCreateDialog dialogTitle="افزودن پکیج به کاربر" dialogId="add-package-to-user" okTitle="افزودن"
    :isOkDisabled="isOkButtonDisabled" @ok="addLessonToSelectedUser">
    <div class="col-12">
      <div>
        <div class="flex flex-row w-full" style="display: flex; width: 100%;"
          v-for="(pkg, index) in addPackagePayload.item" :key="index">
          <packagePicker class="w-full flex-1 filters-width" style="flex: 1;"
            @getLessonCategory="(lessonCategory) => setLessonCategories(index, lessonCategory)">
          </packagePicker>
          <TextInput :key="packagesKey" inputLabel="قیمت" style="flex: 1;" inputPlaceholder="1,000,000"
            v-model="pkg.price" class="w-full flex-1 filters-width">
          </TextInput>
        </div>
      </div>

      <BCol cols="12">

        <TextInput inputLabel="توضیحات" inputPlaceholder="بابت خرید پکیج" v-model="addPackagePayload.description"
          class="w-24 filters-width">
        </TextInput>
      </BCol>
    </div>
  </CustomCreateDialog>
</template>
<script>
export default {
  emits: ["updateLessons"],
  props: {
    externalUserId: {
      type: [String, Number, null],
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
      packagesKey: 0,
      addPackagePayload: {
        userId: null,
        item: [
          {
            lessonCategoryId: null,
            price: null
          }
        ],
        description: "بابت خرید پکیج",
      },
    };
  },
  methods: {
    setLessonCategories(index, lessonCategory) {
      // مقداردهی به آیتم انتخاب‌شده
      this.addPackagePayload.item[index] = {
        lessonCategoryId: lessonCategory.id,
        price: lessonCategory.price,
      };
      this.packagesKey++
      // گرفتن آخرین آیتم
      const lastPackage = this.addPackagePayload.item[this.addPackagePayload.item.length - 1];

      // اگر آخرین آیتم خالی بود (lessonCategoryId = null) دیگه چیزی اضافه نکن
      if (lastPackage.lessonCategoryId === null) {
        return;
      } else {
        this.addPackagePayload.item.push({
          lessonCategoryId: null,
          price: null,
        });
      }
    },

    async addLessonToSelectedUser() {
      try {
        this.isOkButtonDisabled = true;
        this.addPackagePayload.userId = this.externalUserId;

        // حذف آخرین آیتم اگر خالی باشه
        const lastPackage = this.addPackagePayload.item[this.addPackagePayload.item.length - 1];
        if (lastPackage && lastPackage.lessonCategoryId === null) {
          this.addPackagePayload.item.pop();
        }

        let _this = this;
        let addLessonToUserArray = new CreateOrderByAdmin(_this);
        addLessonToUserArray.setRequestParamDataObj(_this.addPackagePayload);

        await addLessonToUserArray.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "اضافه شد",
                icon: "CheckIcon",
                variant: "success",
                text: "درس به کاربر اضافه شد.",
              },
            });
            this.$emit("updateLessons");
            _this.addPackagePayload = {
              userId: null,
              item: [
                {
                  lessonCategoryId: null,
                  price: null,
                },
              ],
              description: "",
            };
            this.$bvModal.hide("add-lesson-to-user");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },

  },
  components: {
    CustomCreateDialog,
    TextInput,
    packagePicker,
    BCol,
    BRow,
  },
};
import { CreateOrderByAdmin } from "@/libs/Api/LessonCategory";
import TextInput from "../Utils/TextInput.vue";
import packagePicker from "./packagePicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import { BCol, BRow } from "bootstrap-vue";
</script>
